<script lang="ts" setup>
import Logo from '@/assets/images/Logo-white.svg'
import { useStoreConfig } from '~/store/storeConfig'

import getLocalizedRoute from '~/utils/getLocalizedRoute'
import { Routes } from '~/enums/Routes'

const storeConfig = useStoreConfig()
</script>

<template>
  <ProCalculateFooter />
  <footer>
    <section class="newsletter py-6 lg:py-[60px] text-white">
      <Newsletter />
    </section>
    <hr class="my-4 lg:my-6 light" />
    <section class="footer pt-6 lg:pt-[60px] text-white">
      <Container>
        <div v-if="storeConfig.isMobile" class="mb-4">
          <NuxtLink :to="getLocalizedRoute(Routes.Index)">
            <img :src="Logo" class="logo" alt="Logo" />
          </NuxtLink>
        </div>
        <div class="flex flex-wrap flex-col lg:flex-row">
          <FaqContacts />
        </div>
        <hr class="my-4 lg:my-6" />
        <Regions />
      </Container>
      <hr class="my-4 lg:my-6 light" />
      <Container>
        <Copyright />
      </Container>
    </section>
  </footer>
</template>

<style lang="postcss" scoped>
footer {
  @apply bg-brand-footer dark:bg-dmGray1;

  hr {
    @apply my-[1.5rem] border-t border-solid border-gray7 dark:border-dmGray4;

    &.light {
      @apply border-gray6 dark:border-dmGray4;
    }
  }
}
</style>
